import { createContext } from 'react'
import { type TunaEditor } from '../plugin-types.js'

export const TunaEditorContext = createContext<TunaEditor | null>(null)
export default TunaEditorContext
